import React, { Component } from 'react';

import Store from "../flux/Store";
import Actions from "../flux/Actions";

import Modal from "./Modal";
import {__} from "../Translator";
import InlineSvg from "../InlineSvg";

import './ProductPresetSlider.css';

import ArrowLeft from './../img/preset-slider-arrow-left.svg';
import ArrowRight from './../img/preset-slider-arrow-right.svg';

class ProductPresetSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productCode: props.productCode,
      productPresets: null,

      presetPrompt: {
        isVisible: false,
        presetName: null,
      },

      presetSliderVisibleItemNumber: 5,
      presetSliderOffset: 0,
    };

    this.productElementWidth = 71;

    this.initialPresetPrompt = { isVisible: false, presetName: null };

    this.onPresetsChange = this.onPresetsChange.bind(this);
  }

  componentDidMount() {
    Store.events.getPresets.addListener(this.onPresetsChange);

    Actions.getPresets(this.state.productCode);
  }

  componentWillUnmount() {
    Store.events.getPresets.removeListener(this.onPresetsChange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ productCode: nextProps.productCode });
  }

  onPresetsChange() {
    this.setState({ productPresets: Store.getPresets(this.state.productCode) });
  }

  render() {
    return null;

    return (
      <div>
        {this.state.productPresets && (
          <div className="productPresetSelect">
            <h4>{__('Need suggestions?')}</h4>
              <div className="productPresetSelect__listContainer">
                {Object.keys(this.state.productPresets).length > this.state.presetSliderVisibleItemNumber ? (
                  <div>
                    <div onClick={() => {
                      if (this.state.presetSliderOffset > 0) {
                        this.setState({ presetSliderOffset: --this.state.presetSliderOffset })
                      }
                    }}>
                      <InlineSvg className="productPresetSelect__slideControl productPresetSelect__slideControl--left" svg={ArrowLeft} />
                    </div>

                    <div onClick={() => {
                      if (Math.abs(this.state.presetSliderOffset + 1) - (Object.keys(this.state.productPresets).length - this.state.presetSliderVisibleItemNumber) <= 0) {
                        this.setState({ presetSliderOffset: ++this.state.presetSliderOffset })
                      }
                    }}>
                      <InlineSvg className="productPresetSelect__slideControl productPresetSelect__slideControl--right" svg={ArrowRight} />
                    </div>
                  </div>
                ) : null}

                <div
                  className={`productPresetSelect__listSliderContainer ${Object.keys(this.state.productPresets).length > this.state.presetSliderVisibleItemNumber ? 'has-scrollbar' : ''}`}
                  style={{ width: Math.min(this.productElementWidth * Object.keys(this.state.productPresets).length, this.productElementWidth * this.state.presetSliderVisibleItemNumber) }}
                >
                  <div
                    className={`productPresetSelect__listSlider`}
                    style={{
                      width: Object.keys(this.state.productPresets).length * this.productElementWidth,
                      transform: `translateX(${-1 * this.state.presetSliderOffset * this.productElementWidth }px)`,
                    }}>
                    {Object.keys(this.state.productPresets).map(presetName => {
                      const preset = this.state.productPresets[presetName];

                      return (
                        <div
                          key={presetName}
                          className="productPresetSelect__preset"
                          style={{
                            backgroundImage: `url(${preset.small_preview_path})`,
                          }}
                          onClick={() => this.setState({ presetPrompt: { isVisible: true, presetName } })}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
          </div>
        )}

        <Modal
          visible={this.state.presetPrompt.isVisible}
          width={705}
          onCloseClick={() => this.setState({ presetPrompt: this.initialPresetPrompt })}
          actions={
            <button className="btn btn-primary productPresetModal__proceedBtn" onClick={() => {
              this.props.onPresetClick(
                this.state.productPresets[this.state.presetPrompt.presetName]
              );

              this.setState({ presetPrompt: this.initialPresetPrompt });
            }}>
              {__('Proceed')}
            </button>
          }
        >
          <div className="productPresetModal">
            <h1>{__('Are you sure you want to change preset?')}</h1>
            <h2>{__('All the changes you\'ve done will be lost')}</h2>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ProductPresetSlider;



// WEBPACK FOOTER //
// ./src/components/ProductPresetSlider.js